<template>
  <div class="search--container">
    <div
      :style="{ top: $vuetify.breakpoint.mdAndUp ? '0' : '56px' }"
      class="search-wrapper pa-10 pb-16"
      v-custom-click-outside="closeSearch"
    >
      <v-btn class="my-0" icon @click="closeSearch">
        <v-icon>close</v-icon>
      </v-btn>
      <div class="d-flex">
        <v-text-field
          ref="search"
          v-model="searchText"
          clearable
          hide-details
          placeholder="Søk etter produkt, kategori, merke eller serie"
          @blur="searchBlurEvent"
          @keydown.esc="closeSearch"
        ></v-text-field>
        <div v-if="!searchText" class="align-self-center px-2">
          <v-icon dark style="cursor: pointer;">close</v-icon>
        </div>
      </div>
      <div
        v-if="$wait.is('loading webshop getProductsBySearchText')"
        class="text-center d-flex mt-7"
      >
        <v-progress-circular
          class="mx-auto align-self-center"
          indeterminate
          size="64"
        />
      </div>
      <div
        v-else-if="searchText && searchText.length > 1"
        v-resize="setWindowHeight"
        :style="{ 'max-height': maxSearchContainerHeight + 'px' }"
        class="search__content my-2"
      >
        <v-row class="px-5" no-gutters>
          <v-col cols="12" md="6">
            <div class="title py-2 font-weight-bold">
              Produkter: <span>{{ productsSearchFilter.length }}</span>
            </div>
            <v-divider />
            <v-list v-if="productsSearchFilter.length" class="pt-0">
              <template v-for="product in productsSearchFilterLimit">
                <v-list-item
                  :key="product.id"
                  class="font-weight-medium"
                  @click="goToProductDetails(product)"
                >
                  <v-list-item-avatar size="50">
                    <v-img :src="product.imgUrl"></v-img>
                  </v-list-item-avatar>
                  <v-list-item-content>
                    {{ product.title }}
                  </v-list-item-content>
                  <v-list-item-action-text
                    class="text--primary d-flex"
                    v-if="product.productDetails"
                  >
                    <div
                      :style="{
                        'white-space':
                          windowSize.x < 350 ? 'pre-wrap' : 'nowrap',
                        'text-decoration':
                          product.salePrice < product.productDetails.price &&
                          product.discounts.length
                            ? 'line-through'
                            : '',
                      }"
                      class="align-self-center mr-2"
                    >
                      <span
                        class="font-weight-regular"
                        :style="{
                          'font-size':
                            product.salePrice < product.productDetails.price &&
                            product.discounts.length
                              ? '10px'
                              : '12px',
                        }"
                        >kr
                      </span>
                      <span
                        class="font-weight-bold"
                        :style="{
                          'font-size':
                            product.salePrice < product.productDetails.price &&
                            product.discounts.length
                              ? '16px'
                              : '20px',
                        }"
                        >{{
                          product.productDetails.price | currency(2, 2)
                        }}</span
                      >
                    </div>
                    <div
                      v-if="
                        product.salePrice < product.productDetails.price &&
                          product.discounts.length
                      "
                      :style="{
                        'white-space':
                          windowSize.x < 350 ? 'pre-wrap' : 'nowrap',
                        color:
                          product.salePrice < product.productDetails.price
                            ? 'red'
                            : '',
                      }"
                      class="align-self-center"
                    >
                      <span class="font-weight-regular" style="font-size: 12px"
                        >kr
                      </span>
                      <span class="font-weight-bold" style="font-size: 20px">{{
                        product.salePrice | currency(2, 2)
                      }}</span>
                    </div>
                    <!-- <div v-if="product.productDetails"
                                                     class="font-weight-regular">
                                                    kr <span class="title">{{
                                                        product.productDetails.price | currency(2,2)
                                                    }}</span>
                                                </div> -->
                    <v-btn v-if="!product.productDetails" icon loading></v-btn>
                  </v-list-item-action-text>
                </v-list-item>
                <v-divider :key="product.id + '-divider'"></v-divider>
              </template>
              <v-btn
                v-if="!showAll && this.$vuetify.breakpoint.smAndDown"
                block
                class="mx-0"
                color="primary"
                outlined
                style="position: relative;"
                @click.stop="showAll = true"
              >
                Vis alle ({{ productsSearchFilter.length }})
              </v-btn>
            </v-list>
            <div v-else class="ml-4 py-3">No match within search</div>
          </v-col>
          <v-col cols="12" md="3">
            <div class="title py-2 font-weight-bold">
              Kategorier: <span>{{ searchProductsCategories.length }}</span>
            </div>
            <v-divider />
            <v-list v-if="searchProductsCategories.length" class="pt-0">
              <template v-for="(category, index) in searchProductsCategories">
                <v-list-item :key="index" @click="searchGoToCategory(category)">
                  <div>
                    {{ category.title }}
                    <b v-if="category.count">({{ category.count }})</b>
                  </div>
                </v-list-item>
              </template>
            </v-list>
            <div v-else class="ml-4 py-3">No match within search</div>
          </v-col>
          <v-col cols="12" md="3">
            <div class="title py-2 font-weight-bold">
              Merker: <span>{{ brandsAndSeriesFiltered.length }}</span>
            </div>
            <v-divider />
            <v-list v-if="brandsAndSeriesFiltered.length" class="pt-0">
              <template v-for="(brandSerie, index) in brandsAndSeriesFiltered">
                <v-list-item
                  :key="index"
                  @click="searchGoToBrandSerie(brandSerie)"
                >
                  <div>
                    {{ brandSerie.titleBrand }} / {{ brandSerie.title }}
                    <b v-if="brandSerie.count">({{ brandSerie.count }})</b>
                  </div>
                </v-list-item>
              </template>
            </v-list>
            <div v-else class="ml-4 py-3">No match within search</div>
          </v-col>
        </v-row>
      </div>
    </div>
  </div>
</template>
<script>
import webshopMixins from "@/components/webshop/cart/webshop.mixins.js";
import { waitFor } from "vue-wait";
import { debounce } from "lodash-es";

export default {
  data: () => ({
    windowHeight: window.innerHeight,
    windowSize: { x: window.innerWidth, y: window.innerHeight },
    showAll: false,
    searchSelectedProduct: null,
    searchText: null,
  }),
  mixins: [webshopMixins],
  methods: {
    setWindowHeight() {
      this.windowHeight = window.innerHeight;
    },
    onResize() {
      this.windowSize = { x: window.innerWidth, y: window.innerHeight };
    },
    executeSearch: debounce(function(string) {
      this.showAll = false;
      waitFor(`loading webshop getProductsBySearchText`, async function() {
        await this.$store.dispatch("webshop/getProductsBySearchText", {
          chainId: this.$route.params.chainId,
          searchText: string,
        });
      }).apply(this);
    }, 300),

    goToProductDetails(product) {
      this.closeSearch();
      this.$router
        .push({
          name: "webshopChainProductDetails",
          params: {
            productId: product.idBase64,
            productTitle: product.urlSafeTitle || "product",
          },
        })
        .catch(() => {});
    },

    activateTabCategory() {
      this.$nextTick(() => {
        const tab = this.$refs["tab-" + this.$route.query.category];
        if (!this.searchText && tab && tab.length) tab[0].toggle();
      });
    },

    searchBlurEvent() {
      //   this.search = this.searchText && this.searchText.length > 1;
      this.activateTabCategory();
    },

    searchGoToCategory(category) {
      let mainCategory = this.categories.find((x) =>
        x.children.map((x) => x.title).includes(category.title)
      );
      this.closeSearch();
      this.$router
        .push({
          name: "webshopChainProductsMainCategories",
          params: { categoryFirst: mainCategory.urlSafeTitle },
          query: {
            [category.webshopCategoryId ? "category" : "mCategory"]:
              category.webshopCategoryId || category.urlSafeName,
          },
        })
        .catch(() => {});
    },

    searchGoToBrandSerie(brandSerie) {
      this.closeSearch();
      this.$router
        .push({
          name: "webshopChainProductsCategories",
          query: {
            serie: [brandSerie.id.Base64Guid],
            brand: [brandSerie.brandId.Base64Guid],
          },
        })
        .catch(() => {});
    },

    // async goToCategory(category) {
    //   this.$eventBus.$emit("webshop-main-category-update", true);
    //   this.closeSearch();
    //   await this.$router
    //     .push({
    //       name: "webshopChainProductsMainCategories",
    //       params: { categoryFirst: category.urlSafeTitle },
    //       query: null,
    //     })
    //     .catch(() => {});
    //   this.$eventBus.$emit("webshop-main-category-update", false);
    // },

    closeSearch() {
      this.$emit("overlay-event", false);
      this.$emit("search-event", false);
      if (this.searchText) {
        this.showAll = false;
        this.searchText = null;
      }
    },
  },
  computed: {
    maxSearchContainerHeight() {
      return this.$vuetify.breakpoint.mdAndUp ? 500 : this.windowHeight - 176;
    },
    searchProductsCategories() {
      return this.$store.getters["webshop/get"](
        "searchProductsCategories"
      ).filter((x) => x.count);
    },

    searchProductsBrands() {
      return this.$store.getters["webshop/get"]("searchProductsBrands");
    },

    productsSearchFilter() {
      return this.$store.getters["webshop/get"]("searchProducts");
    },

    productsSearchFilterLimit() {
      if (this.showAll || this.$vuetify.breakpoint.mdAndUp)
        return this.$store.getters["webshop/get"]("searchProducts");
      else
        return this.$store.getters["webshop/get"]("searchProducts").slice(0, 5);
    },
    brandsAndSeriesFiltered() {
      let array = [];
      this.searchProductsBrands.forEach((x) => {
        let children = x.children.map(
          (y) =>
            new Object({
              ...y,
              count: this.productsSearchFilter
                .map((x) => x.serieName)
                .filter((x) => x === y.title).length,
              titleBrand: x.title,
              brandId: x.id,
            })
        );
        array.push(children);
      });
      return array.flat().filter((x) => x.count > 0);
    },
  },
  watch: {
    searchText(val) {
      // let html = document.getElementsByTagName("HTML")[0];
      // html.style.overflow = val ? "hidden" : "auto";
      if (val && val.length > 1) {
        this.executeSearch(val);
      }
    },
  },
  created() {
    this.$nextTick(() => this.$refs.search.focus());
  },
};
</script>
<style lang="scss" scoped>
.search__content {
  overflow-y: auto;
}

.search--container {
  max-width: 500px;
  //   width: 100%;
  margin: 0 auto;
  z-index: 5;
}

.search-wrapper {
  min-height: 150px;
  position: absolute;
  background-color: white;
  max-width: 1200px;
  margin: 0 auto;
  top: 0;
  left: 0;
  right: 0;
  z-index: 205;

  .v-btn {
    position: absolute;
    right: 0;
    top: 0;
    margin: 10px;
  }
}
</style>
